import { render, staticRenderFns } from "./property-setting-importer-page.vue?vue&type=template&id=5d7c549d&"
import script from "./property-setting-importer-page.vue?vue&type=script&lang=js&"
export * from "./property-setting-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports